







import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductOption } from '@/models/catalog/ProductOption';
import { ProductOptionValue } from '@/models/catalog/ProductOptionValue';
import { isWhite } from '@/services/ColorService';

@Component
export default class ColorSelector extends Vue {
    @Prop()
    public option!: ProductOption;

    public value!: ProductOptionValue;

    public active: number = 0;

    public getColorClass (value: ProductOptionValue) {
        let baseClass = 'product__option-color';

        if (this.active === value.id) {
            baseClass += ' product__option-color--active';
        }

        if (isWhite(value.label)) {
            baseClass += ' product__option-color--white';
        }

        return baseClass;
    }

    public onColorClicked (value: ProductOptionValue) {
        this.value = value;
        this.active = value.id;
        
        setTimeout(() => {
            this.$emit('color:changed');
        }, 50);
    }

    public created () {
        if (this.option.values.length > 0) {
            this.value = this.option.values[0]; 
            this.active = this.value.id;
        }
    }
}
